import React from 'react';
import styled from 'styled-components';

const Styled = styled.span`
    .isOpen {
        transform: rotate(180deg);
    }
`;

interface Props {
    isOpen?: boolean;
}

export const CarretIcon = ({isOpen}: Props): JSX.Element => {
    return (
        <Styled>
            <svg
                className={isOpen ? 'isOpen' : ''}
                width="15"
                height="9"
                viewBox="0 0 15 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M1.52148 1L7.52148 7L13.5215 1" stroke="#1A1A1A" strokeWidth="2" />
            </svg>
        </Styled>
    );
};
